<div class="center">
  <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>
<div class="header">
    <h3>
        Account Creation Verification
    </h3>
    <div>
        Welcome to the Short Code Registry. You have successfully created an account.
    </div>
</div>
<div class="message">
    <div class="side"></div>
    <div *ngIf="verified" class="middle">
        Congratulations! You have successfully verified the email address<br />
        associated with your Short Code Registry account.<br />
        <br />
        Please visit the <a href="/sec/login">Login Page</a> to sign into your account and continue.
    </div>
    <div *ngIf="invalid" class="middle">
        The link is not valid. You may have already verified your email address.<br />
        Please visit the <a href="/sec/login">Login Page</a> to sign into your account and continue.<br />
        If you need additional assistance, please contact Customer Support at {{ config?.customerSupportPhone }}.
    </div>
    <div *ngIf="expired" class="middle">
        Sorry, your verification link has expired. Please click <span class="link" (click)="resendVerification()">here</span> to resend the welcome<br />
        message with a new verification link to the email address on your account.
    </div>
    <div *ngIf="pending" class="middle">
        If you did not receive a welcome email with a verification link,<br/>
        please contact Customer Support at {{ config?.customerSupportPhone }}.
    </div>
    <div class="side"></div>
</div>